import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: "/",
            redirect: "/dashboard",
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "/dashboard",
                    name: "dashboard",
                    component: () => import("@/view/pages/Dashboard.vue")
                },
                {
                    path: "/profile",
                    name: "profile",
                    component: () => import("@/view/pages/Profile.vue")
                },

                {
                    path: "/documents",
                    name: "documents",
                    component: () =>
                        import("@/view/pages/documents/Documents.vue"),
                    children: [
                        {
                            path: "rp-device-register-journal",
                            name: "documents-rp-device-register-journal",
                            component: () => import("@/view/pages/documents/srpu/RPDeviceRegisterJournal.vue"),
                            meta: {accessPage: "DocsSRPU_RPDevices"}
                        },
                        {
                            path: "new-subscriber",
                            name: "documents-new-subscriber",
                            component: () => import("@/view/pages/documents/NewSubscriber.vue"),
                            meta: {accessPage: "DocsNewSubscriber"}
                        },
                        {
                            path: "new-subscriber-update-0",
                            name: "documents-new-subscriber-update-0",
                            component: () => import("@/view/pages/documents/NewSubscriberUpdate0.vue"),
                            meta: {accessPage: "DocsNewSubscriber"}
                        },
                        {
                            path: "new-subscriber-update-1",
                            name: "documents-new-subscriber-update-1",
                            component: () => import("@/view/pages/documents/NewSubscriberUpdate1.vue"),
                            meta: {accessPage: "DocsNewSubscriber"}
                        },
                        {
                            path: "new-subscriber-update-2",
                            name: "documents-new-subscriber-update-2",
                            component: () => import("@/view/pages/documents/NewSubscriberUpdate2.vue"),
                            meta: {accessPage: "DocsNewSubscriber"}
                        },
                        {
                            path: "new-subscriber1",
                            name: "documents-new-subscriber1",
                            component: () => import("@/view/pages/documents/NewSubscriber1.vue"),
                            meta: {accessPage: "DocsNewSubscriber"}
                        },
                        {
                            path: "rp-replacement",
                            name: "documents-rp-replacement",
                            component: () => import("@/view/pages/documents/RPReplacement.vue"),
                            meta: {accessPage: "DocsRPReplacement"}
                        },
                        {
                            path: "rp-replacement-update-0",
                            name: "documents-rp-replacement-update-0",
                            component: () => import("@/view/pages/documents/RPReplacementUpdate0.vue"),
                            meta: {accessPage: "DocsRPReplacement"}
                        },
                        {
                            path: "rp-seal-replacement",
                            name: "documents-rp-seal-replacement",
                            component: () => import("@/view/pages/documents/RPSealReplacement.vue"),
                            meta: {accessPage: "DocsRPSealReplacement"}
                        },
                    ]
                },

                {
                    path: "/reports",
                    name: "reports",
                    component: () =>
                        import("@/view/pages/reports/Reports.vue"),
                    children: []
                },

                {
                    path: "/references",
                    name: "references",
                    component: () =>
                        import("@/view/pages/references/References.vue"),
                    children: [
                        {
                            path: "companies",
                            name: "references-companies",
                            component: () => import("@/view/pages/references/Companies.vue"),
                            meta: {accessPage: "RefsCompanies"}
                        },
                        {
                            path: "res",
                            name: "references-res",
                            component: () => import("@/view/pages/references/Res.vue"),
                            meta: {accessPage: "RefsRes"}
                        },
                        {
                            path: "departments",
                            name: "references-departments",
                            component: () => import("@/view/pages/references/Departments.vue"),
                            meta: {accessPage: "RefsDepartments"}
                        },
                        {
                            path: "res-departments",
                            name: "references-res-departments",
                            component: () => import("@/view/pages/references/ResDepartments.vue"),
                            meta: {accessPage: "RefsResDepartments"}
                        },
                        {
                            path: "rp-models",
                            name: "references-rp-models",
                            component: () => import("@/view/pages/references/RPModels.vue"),
                            meta: {accessPage: "RefsRPModels"}
                        },
                        {
                            path: "subscribers",
                            name: "references-subscribers",
                            component: () => import("@/view/pages/references/Subscribers.vue"),
                            meta: {accessPage: "RefsSubscribers"}
                        },
                        {
                            path: "subscriber-groups",
                            name: "references-subscriber-groups",
                            component: () => import("@/view/pages/references/SubscriberGroups.vue"),
                            meta: {accessPage: "RefsSubscribersGroups"}
                        },
                        {
                            path: "rp-device-suppliers-by-deal",
                            name: "references-rp-device-suppliers-by-deal",
                            component: () => import("@/view/pages/references/RPDeviceSuppliersByDeal.vue"),
                            meta: {accessPage: "RefsRPDeviceSuppliersByDeal"}
                        },
                        {
                            path: "srpu-device-check-service-costs",
                            name: "references-srpu-device-check-service-costs",
                            component: () => import("@/view/pages/references/SRPUDeviceCheckServiceCosts.vue"),
                            meta: {accessPage: "RefsSRPUDeviceCheckServiceCosts"}
                        },
                        {
                            path: "srpu-believers",
                            name: "references-srpu-believers",
                            component: () => import("@/view/pages/references/SRPUBelievers.vue"),
                            meta: {accessPage: "RefsSRPUBelievers"}
                        },
                        {
                            path: "res-feeders",
                            name: "references-res-feeders",
                            component: () => import("@/view/pages/references/ResFeeders.vue"),
                            meta: {accessPage: "RefsRESFeeders"}
                        },
                        {
                            path: "res-substations",
                            name: "references-res-substations",
                            component: () => import("@/view/pages/references/ResSubstations.vue"),
                            meta: {accessPage: "RefsRESSubstations"}
                        },
                        {
                            path: "res-tr-substations",
                            name: "references-res-tr-substations",
                            component: () => import("@/view/pages/references/ResTrSubstations.vue"),
                            meta: {accessPage: "RefsRESTrSubstations"}
                        },
                        {
                            path: "res-electricians",
                            name: "references-res-electricians",
                            component: () => import("@/view/pages/references/ResElectricians.vue"),
                            meta: {accessPage: "RefsRESElectricians"}
                        },
                        {
                            path: "res-streets",
                            name: "references-res-streets",
                            component: () => import("@/view/pages/references/ResStreets.vue"),
                            meta: {accessPage: "RefsRESStreets"}
                        },
                        {
                            path: "subscriber-rates",
                            name: "references-subscriber-rates",
                            component: () => import("@/view/pages/references/SubscriberRates.vue"),
                            meta: {accessPage: "RefsSubscriberRates"}
                        },
                        {
                            path: "subscriber-paid-services",
                            name: "references-subscriber-paid-services",
                            component: () => import("@/view/pages/references/SubscriberPaidServices.vue"),
                            meta: {accessPage: "RefsPaidServicesForSubscribers"}
                        },
                    ]
                },

                {
                    path: "/service",
                    name: "service",
                    component: () =>
                        import("@/view/pages/service/Service.vue"),
                    children: [
                        {
                            path: "users",
                            name: "service-users",
                            component: () => import("@/view/pages/service/Users.vue"),
                            meta: {accessPage: "ServiceUsers"}
                        },
                        {
                            path: "user-sessions",
                            name: "service-user-sessions",
                            component: () => import("@/view/pages/service/UserSessions.vue"),
                            meta: {accessPage: "ServiceUsersSessions"}
                        },
                        {
                            path: "user-actions",
                            name: "service-user-actions",
                            component: () => import("@/view/pages/service/UserActions.vue"),
                            meta: {accessPage: "ServiceUsersActions"}
                        },
                        {
                            path: "system-settings",
                            name: "service-system-settings",
                            component: () => import("@/view/pages/service/SystemSettings.vue"),
                            meta: {accessPage: "ServiceSystemSettings"}
                        },
                        {
                            path: "company-settings",
                            name: "service-company-settings",
                            component: () => import("@/view/pages/service/CompanySettings.vue"),
                            meta: {accessPage: "ServiceCompanySettings"}
                        },

                        {
                            path: "sync-data-monitor",
                            name: "service-sync-data-monitor",
                            component: () => import("@/view/pages/service/sync-data/SyncDataMonitor.vue"),
                            meta: {accessPage: "Service_SyncDataMonitor"}
                        },

                    ]
                },

            ]
        },

        {
            name: "login",
            path: "/login",
            meta: {guestAccess: true},
            component: () => import("@/view/pages/auth/Login")
        },
        {
            name: "logout",
            path: "/logout",
            meta: {guestAccess: true},
            component: () => import("@/view/pages/auth/Logout")
        },

        {
            name: "blank-new-subscriber",
            path: "/blank-new-subscriber",
            meta: {guestAccess: true},
            component: () => import("@/view/pages/blanks/BlankNewSubscriber")
        },
        {
            name: "blank-rp-device-register-journal-passport",
            path: "/blank-rp-device-register-journal-passport",
            meta: {guestAccess: true},
            component: () => import("@/view/pages/blanks/BlankRPDeviceRegisterJournalPassport")
        },
        {
            name: "blank-rp-device-register-journal-qr-code",
            path: "/blank-rp-device-register-journal-qr-code",
            meta: {guestAccess: true},
            component: () => import("@/view/pages/blanks/BlankRPDeviceRegisterJournalQRCode")
        },
        {
            name: "test",
            path: "/test",
            meta: {guestAccess: true},
            component: () => import("@/view/Test")
        },

        {
            path: "*",
            redirect: "/404"
        },
        {
            // the 404 route, when none of the above matches
            path: "/404",
            name: "404",
            meta: {guestAccess: true},
            component: () => import("@/view/pages/error/Error-1.vue")
        }
    ]
});
